import { Module } from 'vuex';

import { LessonXPDetail, LessonXPEarned, Optional, RootState } from 'frontend/types';

const leagueLessonXP: Module<LessonXPEarned, RootState> = {
  namespaced: true,
  state: {
    earned_xp: undefined,
    xp_details: undefined,
    zero_xp_message: undefined,
  },
  getters: {
    earnedXp: (state: LessonXPEarned): Optional<number> => state.earned_xp,
    xpDetails: (state: LessonXPEarned): Optional<LessonXPDetail[]> => state.xp_details,
    zeroXpMessage: (state: LessonXPEarned): Optional<string> => state.zero_xp_message,
  },
  mutations: {
    setValue(state: LessonXPEarned, value: number): void {
      Object.assign(state, value);
    },
  },
};

export default leagueLessonXP;
